import { supportedCurrency } from '@lt/localization';
import { NBSP } from '../constants/userflow';

const DEFAULT_CODE = 'RUB';

export type CurrencyType = keyof typeof supportedCurrency;
export type CurrencySymbols =
  (typeof supportedCurrency)[keyof typeof supportedCurrency];

export const formatCurrency = (
  value: string | number,
  code: CurrencyType = DEFAULT_CODE
): string => {
  const price = Number(value);
  /**
   * Intl не везде доступен (то ли в nodejs у нас какая-то трабла толи в браузерах)
   * Вот задача в которой фиксил: https://leveltravel.atlassian.net/browse/LT-31774
   * Багов сыпалось очень много, так что не помешало бы разобраться
   * Но проверку не убирать для большей поддержки
   *
   * Лучше всего вынести либо @lt/localization, либо на худой случай в монолит
   */
  try {
    const formattedValue = new Intl.NumberFormat('ru-RU').format(price);

    return formattedValue.concat(NBSP, supportedCurrency[code]);
  } catch (err) {
    return `${price}${NBSP}${supportedCurrency[code]}`;
  }
};

export function getCurrencySymbol(
  code: CurrencyType = DEFAULT_CODE
): CurrencySymbols {
  return supportedCurrency[code];
}

export const currencyLow = (code: CurrencyType = DEFAULT_CODE) =>
  code.toLowerCase();
